import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-0966de23"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "hello"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, " 数据从2024年2月4日开始计算，将为您展示指定日期范围内使用过程中被收集的用户信息及次数 ");
}